import React from 'react';

const PageBottomWithButtons = ({ children }) => {

    return( 
    <div className="PageBottomWithButtons row">
        <div className="col-lg-12">
            {children}
        </div>
    </div>
    )
}

export default PageBottomWithButtons;